import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { SortBuilder } from "~/components/SortBuilder"
import { FindIngestionsSortsDto, SortValueDto } from "~/gen/api"

export type IngestionSortsType = FindIngestionsSortsDto & {
  type?: SortValueDto
}

type IngestionsSortsProps = {
  sorts: IngestionSortsType
  setSorts: Dispatch<SetStateAction<FindIngestionsSortsDto>>
}

export const IngestionsSorts = ({ sorts, setSorts }: IngestionsSortsProps) => {
  const { t } = useTranslation("dataTransfer")

  return (
    <SortBuilder<IngestionSortsType>
      sorts={sorts}
      setSorts={setSorts}
      options={[
        {
          label: t("import.list.table.columns.date.header"),
          value: "createdAt",
        },
        {
          label: t("import.list.table.columns.file.header"),
          value: "fileName",
        },
        {
          label: t("import.list.table.columns.user.header"),
          value: "userEmail",
        },
        {
          label: t("import.list.table.columns.status.header"),
          value: "status",
        },
        {
          label: t("import.list.table.columns.rows.header"),
          value: "rowsCount",
        },
        {
          label: t("import.list.table.columns.type.header"),
          value: "type",
        },
      ]}
    />
  )
}
